/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MedPillsIcon16Solid = forwardRef('MedPillsIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.091 7.257a3.625 3.625 0 0 0 5.127 5.126l6.187-6.187A3.625 3.625 0 1 0 7.278 1.07L1.091 7.257Zm10.253-2.122L8.781 7.7 5.776 4.693 8.339 2.13a2.125 2.125 0 0 1 3.005 3.005Z" }),
        React.createElement("path", { d: "M16 12.5a3.5 3.5 0 0 1-5.596 2.803l4.9-4.899c.437.584.696 1.31.696 2.096Z" }),
        React.createElement("path", { d: "M12.5 9c.786 0 1.512.26 2.096.697l-4.9 4.9A3.5 3.5 0 0 1 12.5 9Z" })));
});
